import { createSvgIcon } from "@mui/material";

const MemberAwardIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 36.11 43.55"
        fill="currentColor"
        stroke="currentColor">

        <g>
            <path d="M26.84 23.51c1.52 0 2.96.32 4.27.89-.83-3.75-5.53-4.88-7.67-4.88-1.68 0-3.9-1.75-3.9-3.9v-.25c1.77-2.09 2.93-5.24 2.93-7.56 0-3.77-.98-7.81-6.83-7.81S8.81 4.03 8.81 7.81c0 2.32 1.16 5.47 2.93 7.56v.25c0 2.16-1.71 3.9-3.9 3.9C4.8 19.51.11 21.5.01 25.37c-.03 1.13 0 3.9 0 3.9 0 1.08.87 1.95 1.95 1.95h14.55c1.32-4.45 5.45-7.71 10.32-7.71Z" />
            <path d="M26.84 25.01c-5.11 0-9.27 4.16-9.27 9.27s4.16 9.27 9.27 9.27 9.27-4.16 9.27-9.27-4.16-9.27-9.27-9.27Zm3.54 10.42.84 4.88-4.38-2.3-4.38 2.3.84-4.88-3.54-3.46 4.9-.71 2.19-4.44 2.19 4.44 4.9.71-3.54 3.46Z" />
        </g>
    </svg>

    , 'MemberAwardIcon')

export default MemberAwardIcon
